import {Locale} from '../../../../shared/types/locales';
import {MultilingualText} from '../../../../shared/types/work';

/**
 * Returns the text in the given locale
 * Uses German as default
 */
const getLocalizedText = (
  multilingualText: MultilingualText | undefined,
  locale: string
): string =>
  (multilingualText &&
    (multilingualText[locale as Locale] || multilingualText[Locale.de])) ||
  '';

export default getLocalizedText;
